import React from 'react';
import { articleHeroPropTypes } from './ArticleHeroPropTypes';
import Container from '@Theme/natucare/components/Container/Container';
import Breadcrumbs from '@Theme/natucare/components/Breadcrumbs/Breadcrumbs';
import Picture from '@Theme/natucare/components/Picture/Picture';
import EditorialTeam from './components/EditorialTeam/EditorialTeam';
import InfoBar from './components/InfoBar/InfoBar';
import * as styles from './ArticleHero.module.scss';
const ArticleHero = ({
  breadcrumbs,
  heading,
  description,
  featuredImage,
  editorialTeam,
  activityDates,
  readingTime,
  badges
}) => {
  if (!breadcrumbs && !heading && !description && !featuredImage && !editorialTeam && !activityDates && !readingTime && !badges) {
    return null;
  }

  /**
   * Prop objects with data, functions and states
   */
  const infoBarProps = {
    activityDates,
    readingTime,
    badges
  };
  return /*#__PURE__*/React.createElement("section", {
    className: styles.root
  }, /*#__PURE__*/React.createElement(Container, {
    classname: styles.rootContainer
  }, /*#__PURE__*/React.createElement(Breadcrumbs, {
    items: breadcrumbs
  }), heading && /*#__PURE__*/React.createElement("h1", {
    className: styles.rootHeading
  }, heading), description && /*#__PURE__*/React.createElement("p", {
    className: styles.rootDescription
  }, description), /*#__PURE__*/React.createElement(EditorialTeam, {
    editorialTeam: editorialTeam
  }), featuredImage && /*#__PURE__*/React.createElement(Picture, {
    xs: {
      src: featuredImage.src,
      width: 936,
      height: 358
    },
    alt: featuredImage.alt,
    pictureClassname: styles.rootPicture,
    imgClassname: styles.rootImage
  }), /*#__PURE__*/React.createElement(InfoBar, infoBarProps)));
};
export default ArticleHero;